import Clases from "./clases/clases"
import ContactoMain from "./contactoMain/contactoMain"
import Footer from "./footer/footer"
import Galeria from "./galeria/galeria"
import Home from "./home/home"
import Navb from "./nav/nav"
import Prensa from "./prensa/prensa"
import SobreMi from "./sobremi/sobremi"
import SobreMi2 from "./sobremi2/sobremi2"
import Eventos from "./eventosprivados/eventosprivados"




function HomeES() {
    return (
        <div>
            <Navb></Navb>
            <Home></Home>
            <SobreMi></SobreMi>
            <SobreMi2></SobreMi2>
            <Galeria></Galeria>
            <Clases></Clases>
            <Eventos></Eventos>
            <Prensa></Prensa>
            <ContactoMain></ContactoMain>
            <Footer></Footer>
        </div>
    )
}

export default HomeES